import * as R from 'ramda';


/**
 * doesAnyRouteMatchCurrent :: [String, ReactComponent] -> Object -> Boolean
 */
export const doesAnyRouteMatchCurrent = routes =>
  R.converge(R.contains, [R.prop('route'), () => R.map(R.head, routes)]);


/**
 * routeNameMatchCurrent :: String -> Object -> Boolean
 */
export const routeNameMatchCurrent = R.propEq('pathname');



// WEBPACK FOOTER //
// ./src/routes/utils.js